import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { METRICS_PATH, MetricsService } from './metrics.service';
import { normalizePath } from './normalize-path';

// Registered before CORE_INTERCEPTORS, so `req.url` is still the relative API path.
export const metricsInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.url === METRICS_PATH) {
        return next(req);
    }

    const metricsService = inject(MetricsService);
    const start = performance.now();

    const record = (status: number): void => {
        const now = performance.now();

        metricsService.record({
            type: 'api',
            method: req.method,
            path: normalizePath(req.url),
            status,
            at: Math.round(now),
            route: metricsService.currentRoute(),
            duration: Math.round(now - start),
        });
    };

    return next(req).pipe(
        tap({
            next: (event) => {
                if (event instanceof HttpResponse) {
                    record(event.status);
                }
            },
            error: (error: HttpErrorResponse) => record(error.status),
        }),
    );
};
